export const userTypes = [
  {
    id: 1,
    value: "Regular User",
    label: "regular-user",
  },
  {
    id: 2,
    value: "Creator",
    label: "creator",
  },
  {
    id: 3,
    value: "Admin",
    label: "admin",
  },
];

export const categoryFilters = [
  { id: 1, value: "workout_routines", label: "Workout Routines" },
  {
    id: 2,
    value: "martial_arts_techniques",
    label: "Martial Arts Techniques",
  },
  {
    id: 3,
    value: "nutrition_diet",
    label: "Nutrition & Diet",
  },
  {
    id: 4,
    value: "self_defense_tips",
    label: "Self-Defense Tips",
  },
  {
    id: 5,
    value: "motivation_success_stories",
    label: "Motivation & Success Stories",
  },
];

export const contentData = [
  {
    id: 1,
    title: "A gym setup made for a home, get started now",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    hashtags: ["#bjjblackbelt", "#wrestling_olympian", "#muay_thai_coach"],
    image: require("../assets/images/content-image1.png"),
    video: require("../assets/images/video3.mp4"),
  },
  {
    id: 2,
    title: "John Timbers answers the most common way",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    hashtags: ["#bjjblackbelt", "#wrestling_olympian", "#muay_thai_coach"],
    image: require("../assets/images/content-image2.png"),
    video: require("../assets/images/video2.mp4"),
  },
  {
    id: 3,
    title: "A gym setup made for a home, get started now",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    hashtags: ["#bjjblackbelt", "#wrestling_olympian", "#muay_thai_coach"],
    image: require("../assets/images/content-image3.png"),
    video: require("../assets/images/video1.mp4"),
  },
];

export const topVideos = [
  {
    id: 1,
    title: "John Timbers answers the most common way",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/video-placeholder3.png"),
    views: 1300,
    video: require("../assets/images/video1.mp4"),
  },
  {
    id: 2,
    title: "John Timbers answers the most common way",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/video-placeholder2.png"),
    views: 1300,
    video: require("../assets/images/video4.mp4"),
  },
  {
    id: 3,
    title: "John Timbers answers the most common way",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/video-placeholder1.png"),
    views: 1300,
    video: require("../assets/images/video5.mp4"),
  },
];

export const contentFeedData = [
  {
    id: 1,
    title: "A gym setup made for a home, get started now",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/content-image1.png"),
  },
  {
    id: 2,
    title: "John Timbers answers the most common way",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/content-image2.png"),
  },
  {
    id: 3,
    title: "A gym setup made for a home, get started now",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/content-image3.png"),
  },
  {
    id: 4,
    title: "John Timbers answers the most common way",
    description:
      "Ut enim ad minim veniam uis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
    image: require("../assets/images/video-placeholder2.png"),
  },
];

export const filterData = [
  { label: "Trending", value: "trending" },
  { label: "Recommended for You", value: "recommended" },
  { label: "New Releases", value: "new" },
];

export const filterData2 = [
  { label: "All Content", value: "" },
  { label: "Subscribed Content", value: "subscribed" },
  { label: "Free Content", value: "free" },
];

export const communityFilter = [
  { label: "Trending Creators", value: "creators" },
  { label: "Popular Videos", value: "videos" },
  { label: "Recommended for You", value: "recommended" },
];

export const NavLinks = [
  {
    id: 1,
    title: "Home Page",
    link: "/dashboard",
  },
  {
    id: 2,
    title: "Profile",
    link: "/creator",
  },
  {
    id: 3,
    title: "Community",
    link: "/community",
  },

  {
    id: 4,
    title: "Training Hub",
    link: "/calendar",
  },
];
